import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep, forEach, isEqual, omit, omitBy } from 'lodash-es';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { SavedSearches } from 'src/app/shared/services/saved-searches.service';
import { UniversalSearchModel } from 'src/app/core/models/universal-search.model';

@Pipe({
    name: 'contactsSearchButton',
    standalone: false
})
export class ContactsSearchButtonPipe implements PipeTransform {
    private ignoreFieldsArray = ['required_fields_all', 'sort_direction', 'sort_by', 'tiers', 'page', 'technographics', 'location_types'];

    constructor(private auth: AuthenticationService, private savedSearches: SavedSearches) {}

    transform(currentQuery: any): boolean {
        let activeSearchQuery;
        if (this.savedSearches.contactActiveSearch) {
            activeSearchQuery = this.normalizeSearchQuery(cloneDeep(this.savedSearches.contactActiveSearch.query));
        } else if (this.savedSearches.universalActiveSearch) {
            activeSearchQuery = this.addDefaultAccuracyTier(this.savedSearches.universalActiveSearch.query, this.savedSearches.universalActiveSearch.type);
        } else {
            return false;
        }

        const currentPrunedCriteria = this.omitEmptyProps(cloneDeep(currentQuery));
        const comparisionPrunedCriteria = this.omitEmptyProps(activeSearchQuery);

        return isEqual(
            {...UniversalSearchModel, ...omit(this.pruneEmptyValues(currentPrunedCriteria), this.ignoreFieldsArray)},
            {...UniversalSearchModel, ...omit(this.pruneEmptyValues(comparisionPrunedCriteria), this.ignoreFieldsArray)}
        );
    }

    private normalizeSearchQuery(query: any): any {
        if (typeof query.tiers === 'object') {
            if (query.tiers['humanverified']) {
                query.tiers = '0';
            } else {
                query.tiers = this.auth.getPendingTiers().toString();
            }
        }
        if (query.company_naics_codes && Array.isArray(query.company_naics_codes)) {
            query.company_naics_codes = query.company_naics_codes.join(',');
        }
        return query;
    }

    private omitEmptyProps(obj) {
        return omitBy(obj, function (value) {
            return (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0);
        });
    }

    private pruneEmptyValues(obj) {
        const prunedObject = {};
        forEach(obj, function (value, key) {
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    prunedObject[key] = value;
                }
            } else if (value !== undefined) {
                if (value !== null) {
                    prunedObject[key] = value;
                }
            }
        });
        return prunedObject;
    }

    private addDefaultAccuracyTier(query, type) {
        const clonedQuery = cloneDeep(query);

        return {
            ...clonedQuery,
            ...(type === 'contact' && !clonedQuery?.accuracy_tier_contact ? { accuracy_tier_contact: 'EV' } : {}),
            ...(type === 'company' && !clonedQuery?.accuracy_tier_company ? { accuracy_tier_company: 'MV' } : {}),
        };
    }
}
